import {ChangeDetectionStrategy, Component, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Tidssone} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {FormaterTidssonePipe} from "felles-ng2/pipes/FormaterTidssonePipe";

const debug = initDebugger('TidssoneKomponent');

@Component({
    selector: 'tidssone',
    templateUrl: './tidssone.html',
    styleUrl: 'tidssone.scss',
    imports: [
        FormaterTidssonePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TidssoneKomponent {

    tidssone = input.required<Tidssone>();

    constructor() {
    }

}
